import ReducerGenerator from '../../lib/ReducerGenerator'

const generator = new ReducerGenerator('issuer_period_audience_publishing', '/issuer_period_audience_publishings')
const reducer = generator.generate()

export default reducer
